"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));

var _Button = _interopRequireDefault(require("../baseComponents/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TextTile = function TextTile(props) {
  var modalClasses = (0, _classnames["default"])("tile-component", "text-tile");
  var footerBarElementsLeft = [];
  var footerBarElementsRight = [];
  props.footer.buttonProps && footerBarElementsRight.push( /*#__PURE__*/_react["default"].createElement(_Button["default"], props.footer.buttonProps));
  props.footer.icon && footerBarElementsLeft.push( /*#__PURE__*/_react["default"].createElement(_Icons["default"], props.footer.icon));
  props.footer.text && footerBarElementsLeft.push( /*#__PURE__*/_react["default"].createElement("div", {
    className: "mice"
  }, props.footer.text));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses,
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mainContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "headerContainer",
    "data-value": props.value
  }, props.header.icon ? /*#__PURE__*/_react["default"].createElement(_Icons["default"], props.header.icon) : null, /*#__PURE__*/_react["default"].createElement("div", null, props.header.text)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contentContainer"
  }, props.content.title && /*#__PURE__*/_react["default"].createElement("h5", null, props.content.title), props.content.desc && /*#__PURE__*/_react["default"].createElement("p", null, props.content.desc), props.content.details && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mice details"
  }, props.content.details)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
    right: footerBarElementsRight,
    left: footerBarElementsLeft
  }))));
};

TextTile.propTypes = {
  footer: _propTypes["default"].shape({
    buttonProps: _propTypes["default"].any,
    icon: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }),
  content: _propTypes["default"].shape({
    details: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    desc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }),
  header: _propTypes["default"].shape({
    icon: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  })
};
TextTile.defaultProps = {
  footer: {},
  content: {},
  header: {}
};
var _default = TextTile;
exports["default"] = _default;